export interface MenuProps {
    menu_id: number;
    name: string;
    name_nep: string | null;
    short_name: string;
    icon: string;
    priority: number;
}

export interface LoadingProps {
    loading: boolean;
}

export interface SubMenuProps {
    sub_m_id: number;
    name: string;
    name_nep: string | null;
    short_name: string;
    icon: string;
    priority: number;
}
export interface Province {
    province_id: number;
    province_name: string;
    province_name_nep: string;
}

export interface TapSize {
    sn: number;
    size_name: string;
    tap_size: string;
    remarks: string;
    active: number;
    updated_at: string;
    created_at: string;
}

export interface Tole {
    sn: number;
    tole_name: string;
    tole_name_nep: string;
    updated_at: string;
    created_at: string;
}
export interface Caste {
    caste_id: number;
    caste_name: string;
    caste_name_nep: string;
}

export interface District {
    district_id: number;
    province_name: string;
    district_name: string;
    district_name_nep: string;
}

export interface Municipality {
    muni_id: number;
    muni_name_nep: string;
    muni_name: string;
}

export interface Reader {
    sn: number;
    reader_name: string;
    reader_name_nep: string;
    reader_add: string;
    username: string;
    reader_add_nep: string;
    reader_phone: string;
    reader_date: string;
    branch: number;
    reader_pass: string;
    email: string;
    user_no: number | null;
}
export interface Customer {
    member_sn: number; // BigAutoField in Django
    mem_id?: number; // BigIntegerField in Django, optional
    mem_name: string; // CharField in Django
    mem_name_nep: string; // CharField in Django
    spouse_name: string; // CharField in Django
    spouse_name_nep: string; // CharField in Django
    municipality?: number; // ForeignKey to Municipality, optional
    add_nep?: string; // CharField in Django, optional
    add_eng?: string; // CharField in Django, optional
    ward_no: number; // IntegerField in Django
    district?: number; // ForeignKey to District, optional
    sms_mob_no?: string; // CharField in Django, optional
    phone_no?: string; // CharField in Django, optional
    dob?: string; // CharField in Django, optional
    ctiz_no?: string; // CharField in Django, optional
    ctiz_issue_district?: number; // ForeignKey to District, optional
    province?: number; // ForeignKey to Province, optional
    gender?: number; // IntegerField in Django, optional
    caste?: number; // ForeignKey to Caste, optional
    pan_no?: string; // CharField in Django, optional
    family_male_no?: number; // IntegerField in Django, optional
    family_female_no?: number; // IntegerField in Django, optional
    father_name?: string; // CharField in Django, optional
    father_name_nep?: string; // CharField in Django, optional
    grand_father_name?: string; // CharField in Django, optional
    grand_father_name_nep?: string; // CharField in Django, optional
    old_sys_no?: string; // CharField in Django, optional
    reg_date_n?: string; // CharField in Django, optional
    meter_conn_date?: string; // CharField in Django, optional
    marga_tole?: number; // ForeignKey to Tole, optional
    tole_name_nep?: string;
    meter_reading_zone?: string; // CharField in Django, optional
    serial_no?: string; // CharField in Django, optional
    serial_suffix?: string; // CharField in Django, optional
    area_no?: number; // BigIntegerField in Django, optional
    meter_status?: number; // IntegerField in Django, optional
    customer_type?: number; // IntegerField in Django, optional
    meter_type?: number; // IntegerField in Django, optional
    tap_type?: number; // IntegerField in Django, optional
    tap_no?: number; // IntegerField in Django, optional
    discount_unit?: number; // IntegerField in Django, optional
    reader?: number; // IntegerField in Django, optional
    reading_day?: number; // IntegerField in Django, optional
    meter_sn?: string; // CharField in Django, optional
    reading_effective?: string; // CharField in Django, optional
    consumers_no?: number; // BigIntegerField in Django, optional
    emi?: number; // IntegerField in Django, optional
    tap_status?: number; // IntegerField in Django, optional
    nak_sa_no?: number; // IntegerField in Django, optional
    kitta_no?: number; // IntegerField in Django, optional
    area_land?: string; // CharField in Django, optional
    purja_no?: number; // IntegerField in Django, optional
    house_no?: string; // CharField in Django, optional
    sadhiyar_no?: number; // BigIntegerField in Django, optional
    branch?: number; // IntegerField in Django, optional
    active: number; // IntegerField in Django
    block_no?: number; // IntegerField in Django, optional
    area_supply?: string; // CharField in Django, optional
    tap_size?: number; // ForeignKey to TapSize, optional
    ferrule_meter_distance?: string; // CharField in Django, optional
    ground_level_ferrule?: string; // CharField in Django, optional
    distance?: string; // CharField in Django, optional
    mian_pipe_size?: string; // CharField in Django, optional
    photo?: string; // ImageField in Django, optional, URL or file path
    citz_photo?: string; // ImageField in Django, optional, URL or file path
    thumb_photo?: string; // ImageField in Django, optional, URL or file path
    signature1?: string; // ImageField in Django, optional, URL or file path
    lal_purja?: string; // ImageField in Django, optional, URL or file path
    province_name?: string;
    tole_name?: string;
    profile_lock?: number;
}

export interface GeneralLedger {
    glid: number,
    gl_name: string,
    gl_name_nep: string,
    gl_type: number,
    rpt_det_mode: number,
    actual_glid: number,
    gl_status: number,

}
export interface VoucherEntry {
    date_en: string;
    fiscal_year_date: string;
    fiscal_start: string;
    date_ne: string;
    debitamt: string;
    creditamt: string;
    user_no: number;
    chequeno: string;
    bearername: string;
    bank_sglsn: string;
    dep_particular_id: string;
    billing_no: string;
    voucher_type: string;
    is_debit?: number | null;
    part_is_debit?: number | null;
    trancomment: string;
    bill_print: number;
    ledger_start_date: string;
    ledger_end_date: string;
    glid: string;
    cash_sglsn: string;
    voucher_no: string;
    voucher_no_1: string;
    trans_counter_code: string;
    voucher_kind: string;
    member_sn: string;
    depositmonth: string;
    view_full_leader?: boolean | string;
    particularid: string;
    particular_name: string;
    sglsn: string;
    deposityear: string;
    mem_cate_id: number;
    billingcomment?: string;
    continue_bill?: number;
}

export interface ContraVoucherInfoProps {
    fiscal_start: string | null;
    date_enn: string | null;
    date_ne: string | null;
    user_id: number | null;
}
export interface SubLedger {
    sglsn: number;
    sub_ledg_id: number;
    sub_ledg_name: string;
    sub_ledg_name_nep: string;
    glid: number;
    diff_ac_on: number;
    status: number;
    mem_cate_id: number | string;
    show_det_mode: number;
    gl_type_cat?: number | null;
    branch_id: number;
    dep_rate: number;
}

export interface VoucherEntrySubLedgerProps {
    data: {
        sub_ledger: SubLedger[];
        account_id: number | null;
        sub_account_sn: number | null;
        bank_name_list: SubLedger[];
        cheque_name_list: SubLedger[];
        card_name_list: SubLedger[];
        wallets_name_list: SubLedger[];
        status: number | string;

    } | null;
    loading: boolean;
    error: string | null;
}

export interface VoucherEntryGeneralLedgerProps {
    data: {
        data: GeneralLedger[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
}


export interface Particular {
    particular_id: number;
    particular_name: string;
    particular_name_nep: string;
    glid: number;
    is_debit: number;
    status: number;
    particu_for_assets: number;
    assets_dep_pers: number | null;
    sub_gl_related_id: number;
    virtual_pid: number;
    branch_id: number;
}
// types.ts or models.ts
export interface PostalReceive {
    sn: number;
    reference_no: string;
    date_ne: string;
    date_en?: string;
    from_title?: string;
    address?: string;
    note?: string;
    to_title: string;
    letter_no?: string;
    doc?: string; // URL of the document
    created_at: string; // ISO 8601 date string
}

export interface FiscalYear {
    fiscal_year_id: number;
    fiscal_year_name?: string;
    from_date_n: string;
    to_date_n: string;
    is_current_fiscal: number; // Change this to number
    status: number;
}

export interface UnitRate {
    sn: number;
    tap_size_name: string;
    tap_type: number | string;
    unit_from: number;
    unit_to: number;
    unit_amt: number;
    per_unit: number | string;
    remarks: string;
    updated_at: string; // You might consider using `Date` instead, if you plan to handle this as a date object.
    created_at: string; // Same as above, consider using `Date`.
    tap_size: number;
}


export interface CustomerEMI {
    total_emi: number;
    total_pay: number;
    member_sn: number;
    mem_name: string;
    add_eng: string;
    ward_no: number;
    spouse_name: string;
    phone_no: string;
    dob: string;
    meter_conn_date: string;
    serial_no: string;
    father_name: string;
    gender: number;
    tole_name: string;
    province_name: string;
    district_name: string;
    remaining_amount: number;
    tap_no: number;
}
export interface Organization {
    sn: number;
    org_name: string;
    org_name_nep: string;
    org_add: string;
    org_add_nep: string;
    org_phone: string;
    email: string;
    org_phone_nep: string;
    org_reg: string;
    org_reg_nep: string;
    org_pan: string;
    org_pan_nep: string;
    org_estd: string;
    org_estd_nep: string;
    org_stable_date: string;
    logo: string | null; // Adjust type based on actual data; might be URL or file reference
    head_sign: string | null; // Adjust type based on actual data; might be URL or file reference
}

export interface ProductMaster {
    sn: number;              // BigAutoField maps to number
    name: string;           // CharField maps to string
    name_nep: string;       // CharField maps to string
    des?: string;           // TextField with null=True maps to string or undefined
    des_nep?: string;       // TextField with null=True maps to string or undefined
    status: number;        // BooleanField maps to boolean
    remarks?: string;       // TextField with null=True maps to string or undefined
}

// Define the TypeScript interface based on the provided data
export interface ItemCategory {
    name: string;              // Corresponds to "name"
    name_nep: string;         // Corresponds to "name_nep"
    product_master: number;   // Corresponds to "product_master"
    product_master_name: string; // Corresponds to "product_master_name"
    sn: number;               // Corresponds to "sn"
    status: number;          // Corresponds to "status"
}

export interface ProductUnit {
    sn: number;
    unit_name: string;
    short_name: string;
    remarks: string;
    status: number;
}
// Define the ProductStore TypeScript interface
export interface ProductStore {
    sn: number;                // BigAutoField maps to number
    store_name: string;        // CharField maps to string
    store_name_nep: string;    // CharField maps to string
    store_code?: string;       // CharField with null=True maps to string or undefined
    email?: string;            // CharField with null=True maps to string or undefined
    phone_no?: string;         // CharField with null=True maps to string or undefined
    address: string;           // CharField maps to string
    address_nep: string;       // TextField maps to string
    status: number;            // IntegerField maps to number
    list?: string;             // TextField with null=True maps to string or undefined
    remarks?: string;          // TextField with null=True maps to string or undefined
    branch: number;            // IntegerField maps to number
}

export interface Supplier {
    sn: number;  // BigAutoField is typically a number
    supp_name: string;
    supp_name_nep: string;
    sup_phone?: string;  // Optional fields
    sup_email?: string;
    sup_address: string;
    sup_address_nep: string;
    per_name?: string;
    per_name_nep?: string;
    per_phone?: string;
    per_email?: string;
    remarks?: string;
    branch?: number;
}

export interface OptMasterCategory {
    name: string;
    sn: number;
    name_nep: string;
    status: number;
}

export interface OptProductUnit {
    sn: number;
    short_name: string;
    status: number;
}

export interface OptProductStore {
    sn: number;
    store_name: string;
    status: number;
}

export interface OptProductSupplier {
    sn: number;
    supp_name: string;
    per_name?: string;
}
export interface OptPaymentMode {
    sn: number;
    sub_ledger_type_name: string;
    sub_ledger_type_name_nep?: string;
}

export interface OptSubGLLedger {
    sglsn: number;
    sub_ledg_name: string;
    status?: number;
    link_mode?: number;
}
export interface ProductItemOpt {
    status: number;
    message: string;
    master_category: OptMasterCategory[];
    product_unit?: OptProductUnit[];
    product_store?: OptProductStore[];
    product_suppiler?: OptProductSupplier[];
    payment_mode?: OptPaymentMode[];
    sub_ledger?: OptSubGLLedger[];
}

export interface Product {
    sn: number;
    sub_master: number;
    purchase_unit: number;
    sales_unit: number;
    pro_name: string;
    pro_name_nep: string;
    pur_rate: number;
    sales_rate: number;
    pro_notes?: string;
    status: number;
    opening_stock: number;
    stock_limit_qty: number;
    start_date: string;
    discable: number | string;
    disc_perc: number;
    disc_amt: number;
    model_no?: string;
    char_code?: string;
    sizes?: number;
    mat_type?: string;
    with_vat: number | string;
    purchase_unit_name?: string;
    sales_unit_name?: string;
    sub_master_name?: string;
    product_master?: number;
    vat_perc?: number;
}

export interface OptProductList {
    sn: number;              // Corresponds to "name"
    pro_name: number;
    sizes?: number;        // Corresponds to "name_nep"
    pur_rate?: number;
    sales_rate?: number;
    vat_perc?: number;
    disc_amt?: number;
    disc_perc?: number;
    purchase_unit_name?: string;
    total_available?: number;   // Corresponds to "product_master"
}
export interface PurchaseProductList {
    sn: number;
    master_category: number;              // Corresponds to "name"
    pur_sale_date: string;
    product_category?: number;        // Corresponds to "name_nep"
    product: number;
    store?: string | number;
    suppiler?: number;   // Corresponds to "product_master"
    purchase_status: number;
    payment_mode: number;
    sglsn: number;
    purchase_rate: number;
    purchase_qty: number;
    tot_amt: number | string;
    pur_tot_amt: number;
    remarks?: string;
    vat_amt?: number;
    dis_amt?: number;
    dis_per?: number;
}
export interface TransactionPurchase {
    sn: number;
    tsn: bigint | null;
    sale_issue: number;
    purchase_qty: string;
    pur_tot_amt: number;
    dis_amt: number;
    dis_per: number;
    vat_amt: number;
    purchase_rate: number;
    sup_phone: string;
    pur_sale_date: string;
    purchase_unit_name: string;
    store_name: string;
    phone_no: string;
    suppiler_name: string;
    product_name: string;
    active: number;
    remarks?: string;
    purchase_status: number;
}
export interface OptProductMemList {
    member_sn: number;              // Corresponds to "name"
    mem_name: string;
    phone_no?: string;        // Corresponds to "name_nep"
    add_eng?: string;
}
export interface OptProductIssueList {
    product_id: number;
    pro_name: string;              // Corresponds to "name"
    total_purchase: number;
    sales_rate: number;
    store_id?: number;
}
export interface OnAmtList {
    total_product_amt: number;
    final_total_amt: number;
    vatAmt: number; // Add this line
}
export interface IssueProductListReducer {
    master_category: number;              // Corresponds to "name"
    pur_sale_date: string;
    product_category?: number;        // Corresponds to "name_nep"
    product: number;
    store?: string | number;
    payment_mode: number;
    sglsn?: number;
    purchase_rate?: number;
    issue_qty: number;
    tot_amt?: number | string;
    due_date: string;
    remarks?: string;
    vat_amt?: number;
    dis_amt?: number;
    dis_per?: number;
    member_sn: number;
    pur_tot_amt?: number | null;
}

export interface IssueProduct {
    sn: number;
    tsn: number | null;
    sale_issue: number;
    mem_name: string;
    add_eng: string;
    member_sn: number;
    mem_phone_no: string;
    remarks: string;
    due_date: string;
    returned: number | string;
    issue_qty: number;
    pur_sale_date: string;
    sales_unit_name: string;
    store_name: string;
    store_phone_no: string;
    product_name: string;
    mem_category_name?: string;
    product_category_name?: string;
}

export interface SalesProductListReducer {
    master_category: number;              // Corresponds to "name"
    pur_sale_date: string;
    product_category?: number;        // Corresponds to "name_nep"
    product: number;
    store?: string | number;
    payment_mode: number;
    sglsn?: number;
    sales_rate?: number;
    sales_qty: number;
    tot_amt?: number | string;
    remarks?: string;
    vat_amt?: number;
    dis_amt?: number;
    dis_per?: number;
    member_sn: number;
    pro_name: string;
    sales_tot_amt?: number;
}


export interface SalesProduct {
    sn: number;
    tsn: number | null;
    sale_issue: number;
    mem_name: string;
    add_eng: string;
    member_sn: number;
    mem_phone_no: string;
    remarks: string;
    due_date: string;
    returned: number | string;
    sales_qty: number;
    pur_sale_date: string;
    sales_unit_name: string;
    store_name: string;
    store_phone_no: string;
    product_name: string;
    mem_category_name?: string;
    product_category_name?: string;
}

export interface SearchMemberList {
    member_sn: number;              // Corresponds to "name"
    mem_name: string;
    phone_no?: string;        // Corresponds to "name_nep"
    add_eng?: string;
    tole_name?: string;
    tap_size_name?: string;
    reader?: string;
    tap_size?: number;
    reader_name?: string;
    spouse_name?: string;
    consumers?: {
        unit_total: string;
    }
}
export interface MemberInfoProps {
    status: number;
    message: string;
    results: {
        member_sn: number;
        mem_name: string;
        phone_no: string;
        add_eng: string;
        active: number;
        marga_tole_name: string;
    } | null
}
export const defaultEmployeeData: MemberInfoProps = {
    status: 0,
    message: "",
    results: null
};

export interface OptProductSalesList {
    product_id: number;              // Corresponds to "name"
    pro_name: number;
    sizes?: number;        // Corresponds to "name_nep"
    pur_rate?: number;
    sales_rate?: number;
    vat_perc?: number;
    disc_amt?: number;
    disc_perc?: number;
    total_purchase?: number;   // Corresponds to "product_master"
}


export interface SaleResult {
    sn: number;
    tsn: number | null;           // Assuming 'tsn' can be null
    sale_issue: number;
    remarks: string;
    sales_qty: number;
    purchase_status: number;
    sales_tot_amt: number;
    dis_amt: number;
    dis_per: number;
    vat_amt: number;
    sales_rate: number;
    pur_sale_date: string;        // Keeping it as a string, consider converting to Date if needed
    sales_unit_name: string;
    store_name: string;
    phone_no: string;
    product_name: string;
    mem_name: string;
    add_eng: string;
    mem_phone_no: string;
    marga_tole_name: string;
}

export interface SaleResponse {
    results: SaleResult[];
}
export interface EmployeeSalary {
    emp_salary_id: number;
    mem_name: string;
    mem_name_nep: string;
    add_nep?: string;
    add_eng?: string;
    ward_no?: number;
    sms_mob_no?: string;
    phone_no: string | null;
    dob: string | null;
    gender?: number;
    photo: string | null;
    date_of_joining: string | null;
    date_of_leaving: string | null;
    shift?: number;
    bank_holder_name: string | null;
    acc_number: string | null;
    bank_name: string | null;
    branch_name: string | null;
    bank_code: string | null;
    initial_salary: number;
    grade_count: number;
    grade_amt: number;
    allowance: number;
    tax_amount: number;
    pr_status: number;
    pf_amount: number;
    pf_thap_amt: number;
    app_date: string;
    branch: number;
    ss_tax: number;
    insurance: number;
    ss_found: number;
    remarks: string | null;
    status: number;
    qualification: string | null;
    training: string | null;
    lang: string | null;
    member_sn: number;
    designation: string | null;
    father_name?: string;
    father_name_nep?: string;
}
export interface Designation {
    sn: number; // Serial Number or ID
    name: string; // Name in English
    name_nep: string; // Name in Nepali
    remarks: string | null; // Additional remarks or comments
    status: number; // Status (e.g., 1 for active, 0 for inactive)
}
// Define an interface for the individual item in the data array
export interface EmployeePayrollData {
    sn: number; // Serial Number
    mem_name: string; // Member Name
    mem_name_nep: string; // Member Name in Nepali
    designation_name: string; // Designation Name
    hired_id: number; // Hired ID
    yearr: number; // Year
    monthh: number; // Month
    branch: number; // Branch ID
    basic_sal: number; // Basic Salary
    grade_count: number; // Grade Count
    grade_amount: number; // Grade Amount
    basic_tot_amount: number; // Basic Total Amount
    pf: number; // Provident Fund
    pf_thap: number; // Provident Fund Thap
    thap: number; // Thap (Allowance)
    abs_day: number; // Absent Days
    att_day: number; // Attended Days
    abs_amt: number; // Absent Amount
    other_al: number; // Other Allowances
    total_salary: number; // Total Salary
    pf_total: number; // Total Provident Fund
    tax: number; // Tax Amount
    sa_su_tax: number; // Social Security Tax
    other_less_amt: number; // Other Less Amount
    abs_day_less: number; // Absent Day Less
    abs_amt_less: number; // Absent Amount Less
    net_salary: number; // Net Salary
    posted_tsn: number | null; // Posted TSN (can be null)
    remarks: string | null; // Remarks (can be null)
    upadan_thap: number; // Upadan Thap
    upadan_katti: number; // Upadan Katti
    post: number; // Post
    emp_salary: number; // Employee Salary
    designation: number; // Designation ID
}

export interface FiscalYearProps {
    fiscal_year_id: number;
    fiscal_year_name: string;
    from_date_n: string;
    to_date_n: string;
    is_current_fiscal: number;
    status: number;
    updated_at?: string;
    created_at?: string;
}
export interface MahasulListProps {
    sn: number;
    mem_name: string;
    marga_tole_name: string;
    date_e: string;
    date_n: number;
    mem_id: number;
    unit_total?: number;
    consume_unit?: number;
    consume_amt?: number;
    post_tsn?: number;
    post?: number;
    bill_no?: number;
    deleted?: number;
    meter_status?: number;
    reader_name?: string;
    member_sn?: number;
    updated_at?: string;
    created_at?: string;
}


export interface BillingEntryProps {
    date_en: string;
    date_ne: string;
    clr_date_n: string;
    marga_tole_name?:string;
    mem_name?:string;
    clr_date_e: string;
    fiscal_year_name: string;
    fiscal_from_date: string;
    user_no: number;
    receive_amt: number;
    adjust_advance: boolean;
    right_total_amt: number;
    tot_particular_amt: number;
    total_every_month_amt: number;
    advance_amt: number;
    total_mahasul_amt: number;
    fine_amt: number;
    chhut_amt: number;
    refund_advance_amt: number;
    payment_mode: string;
    total_right_top_amt: number;
    bank_sglsn: string;
    glid: string;
    cash_sglsn: string;
    deposit_year: string;
    deposit_month: string;
    member_sn: number;
    total_pay_amt: number;
    emi_amt: number;
    emi_amt_due: string;
    emi_paid: string;
    billing_no: number;
    check_ad_advace: boolean;

}

export interface ProfileData {
    member_sn: number;
    tap_size_name: string;
    province_name: string;
    district_name: string;
    ctiz_issue_district_name: string;
    municipality_name: string;
    tole_name: string;
    mem_id: number | null;
    mem_name: string;
    mem_name_nep: string;
    spouse_name: string;
    spouse_name_nep: string;
    add_nep: string;
    add_eng: string;
    ward_no: number;
    sms_mob_no: string;
    phone_no: string;
    dob: string; // Consider converting to Date object if needed
    ctiz_no: string;
    gender: number;
    pan_no: string;
    family_male_no: number;
    family_female_no: number;
    father_name: string;
    father_name_nep: string;
    grand_father_name: string;
    grand_father_name_nep: string;
    old_sys_no: string;
    reg_date_n: string; // Consider converting to Date object if needed
    meter_conn_date: string; // Consider converting to Date object if needed
    meter_reading_zone: string;
    serial_no: string;
    serial_suffix: string;
    area_no: number;
    meter_status: number;
    customer_type: number;
    meter_type: number;
    tap_type: number;
    tap_no: number;
    discount_unit: number;
    reader: number;
    reading_day: number;
    meter_sn: string;
    reading_effective: string;
    consumers_no: number;
    emi: number | null;
    tap_status: number | null;
    nak_sa_no: string | null;
    kitta_no: string | null;
    area_land: string | null;
    purja_no: string | null;
    house_no: string | null;
    sadhiyar_no: number;
    branch: number;
    active: number;
    block_no: string | null;
    area_supply: string | null;
    ferrule_meter_distance: string | null;
    ground_level_ferrule: string | null;
    distance: string | null;
    mian_pipe_size: string | null;
    photo: string;
    citz_photo: string | null;
    thumb_photo: string | null;
    signature1: string | null;
    lal_purja: string | null;
    mem_cate: number;
    profile_lock: number;
    municipality: number;
    district: number;
    ctiz_issue_district: number;
    province: number;
    caste: number;
    marga_tole: number;
    tap_size: number;
}

export interface TransactionRpt {
    glid: number;
    glname: string | null;
    glnamenep: string | null;
    subledgerid: number;
    subledgname: string | null;
    subledgnamenep: string | null;
    subamt: number | null;
    curyear_dr: number | null;
    curyear_cr: number | null;
    gl_type: number | null;
}

export interface LedgerListProps {
    tsn: number;
    dated: string | null;
    particulars: string | null;
    particunamedev: number;
    billrno: string | null;
    chequeno: string | null;
    dramt: number | null;
    cramt: number | null;
    subaccbal: number | null;
    subdrcr: number | null;
    rem: string | null;
    tasn: number | null;
    tmsn: number | null;

}


export interface BillingParticularProps {
    particular_id: number;
    particular_name: string | null;
    amount: number | null;
}

export interface BillingListProps{
    glid: number;
    sglsn: number;
    particularname: string;
    particularnamenep: string;
    cramt: number;
    billcoments: string|null;
}

export interface SingleMemberBillProps{
    member_sn: number;
    mem_name: string;
    mem_name_nep: string;
    add_nep: string;
    add_eng: string|null;
    sms_mob_no: string|null;
    ward_no: number|null;
    tole_name: string|null;
    tole_name_nep: string|null;
}

export interface BillingReportDataProps{
    receipt_list: BillingListProps[];
    member_details: SingleMemberBillProps;
    date_ne: string | null;
    receipt_no: number | null;
}

export interface BillingState {
    BillingList: BillingReportDataProps | null; // or default value
}
export interface StructureProps{
    org_name: string;
    org_name_nep: string|null;
    org_estd_nep: string|null;
    org_estd: string|null;
    org_add_nep: string|null;
    org_add: string|null;
    email: string|null;
    head_sign: string|null;
    logo: string;
    org_pan: string|null;
    org_pan_nep: string|null;
    org_phone: string|null;
    org_phone_nep: string|null;
    org_reg: string|null;
    org_reg_nep: string|null;
    org_stable_date: string|null;
    sn: number;
}

export interface AccountReportProps{
    date_from: string |null;
    date_to: string |null;
    date: string |null;
}


export interface StockReportList {
    product_id: number;
    pro_name: string;
    store_name: string;
    store_id: number;
    vat_perc: number;
    disc_amt: number;
    disc_perc: number;
    sub_master_id: number;
    total: number;
    sales_rate: number;
  }
  export interface MahasulListDetailsProps {
    sn: number;
    tole_name: string;
    mem_name: string;
    add_eng: string;
    phone_no: string;
    meter_sn: string;
    date_e: string; // You may want to use Date type if you convert this into Date objects
    date_n: string; // You may want to use Date type for Nepali dates if you're working with Nepali date formats
    mem_id: number;
    unit_total: number;
    consume_unit: number;
    consume_amt: number;
    post_tsn: string | null;
    post: number;
    bill_no: string | null;
    deleted: number;
    app_posting: number;
    meter_status: number;
    sglsn: string | null;
    updated_at: string; // ISO 8601 formatted date string
    created_at: string; // ISO 8601 formatted date string
    member_sn: number;
    reader: number;
}